const NotFound = () => {
	return (
		<>
			<div>
				<p className="text-8xl font-bold text-center">404</p>
				<p className="text-2xl font-bold text-center">Not Found</p>
			</div>
		</>
	);
};

export default NotFound;
